import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { CommonProps, Direction } from "../types";
import { getCurrentWeek } from "../legacyUtils";
import {
    CalendarHeaderWrapper,
    Arrow,
    WeeksContainer,
    ArrowPlaceHolder,
    WeekIntervalContainer,
    WeekNumber,
} from "./StyledComponents";
import DatePicker from "./DatePicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatWeekInterval } from "./CalendarBody/utils";
import {useTranslation} from "react-i18next";

interface Props extends CommonProps {
    weekInterval: readonly [Date, Date];
    isSettings?: boolean;
    setWeeks: React.Dispatch<React.SetStateAction<number[]>>;
}

const CalendarHeader = ({
    moveSlide,
    week,
    weekInterval,
    isSettings,
    setWeeks,
}: Props) => {
    const { t } = useTranslation();
    const currentWeek = getCurrentWeek();
    const isFirstWeek = currentWeek === week;
    const hasNextWeek = week !== currentWeek - 1;

    return (
        <CalendarHeaderWrapper>
            {isFirstWeek ? (
                <ArrowPlaceHolder />
            ) : (
                <Arrow onClick={() => moveSlide(Direction.PREV)}>
                    <FontAwesomeIcon className="fas" icon={faChevronLeft} />
                </Arrow>
            )}
            <WeeksContainer>
                <WeekNumber
                    isSettings={!!isSettings}
                >{`${week}. ${t('week')}`}</WeekNumber>
                <WeekIntervalContainer>
                    <div>{formatWeekInterval(weekInterval)}</div>
                    <DatePicker monday={weekInterval[0]} setWeeks={setWeeks} />
                </WeekIntervalContainer>
            </WeeksContainer>
            {!hasNextWeek ? (
                <div />
            ) : (
                <Arrow onClick={() => moveSlide(Direction.NEXT)}>
                    <FontAwesomeIcon icon={faChevronRight} />
                </Arrow>
            )}
        </CalendarHeaderWrapper>
    );
};

export default CalendarHeader;
